import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - management
const ClientsPage = Loadable(lazy(() => import('pages/management/clients')));
const SitesPage = Loadable(lazy(() => import('pages/management/sites')));
const LicensesPage = Loadable(lazy(() => import('pages/management/licenses')));
const LicenseHistoryPage = Loadable(lazy(() => import('pages/management/licenses/history')));
const AuditsPage = Loadable(lazy(() => import('pages/management/audits')));
const NewAuditPage = Loadable(lazy(() => import('pages/management/audits/NewAudit')));

const ReportsPage = Loadable(lazy(() => import('pages/reports/ReportsPage')));
const SunburstPage = Loadable(lazy(() => import('pages/reports/SunburstPage')));
const NotificationsPage = Loadable(lazy(() => import('pages/reports/NotificationsPage')));

// render - user management
const UsersPage = Loadable(lazy(() => import('pages/user-management/users')));
const RolesPage = Loadable(lazy(() => import('pages/user-management/roles')));
const AccessControlPage = Loadable(lazy(() => import('pages/user-management/access-control')));

// render - settings
const EmailSettingsPage = Loadable(lazy(() => import('pages/settings/EmailSettingsPage')));
const SchedulerPage = Loadable(lazy(() => import('pages/settings/SchedulerPage')));

// ==============================|| MAIN ROUTING ||============================== //



const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'management',
      children: [
        {
          path: 'clients',
          element: <ClientsPage />
        },
        {
          path: 'sites',
          element: <SitesPage />
        },
        {
          path: 'licenses',
          element: <LicensesPage />
        },
        {
          path: 'licenses/history',
          element: <LicenseHistoryPage />
        },
        {
          path: 'audits',
          element: <AuditsPage />
        },
        {
          path: 'audits/new',
          element: <NewAuditPage />
        }
      ]
    },
    {
      path: 'reports',
      children: [
        {
          path: '',
          element: <ReportsPage />
        },
        {
          path: 'graph',
          element: <SunburstPage />
        }
      ]
    },
    {
      path: 'notifications',
      element: <NotificationsPage />
    },
    {
      path: 'user-management',
      children: [
        {
          path: 'users',
          element: <UsersPage />
        },
        {
          path: 'roles',
          element: <RolesPage />
        },
        {
          path: 'access-control',
          element: <AccessControlPage />
        }
      ]
    },
    {
      path: 'settings',
      children: [
        {
          path: 'email',
          element: <EmailSettingsPage />
        },
        {
          path: 'email-settings',
          element: <EmailSettingsPage />
        },
        {
          path: 'scheduler',
          element: <SchedulerPage />
        }
      ]
    },

    {
      path: 'typography',
      element: <Typography />
    },

    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
